import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AnchorButton } from '@/components/ui';
import { isNative } from '@/native/platform';
import { fetchAppRelease, type AppRelease } from './app-release';

/**
 * 登录页下面的「下载安卓 App」（CR-058）。
 *
 * 工人第一次拿到手机，是先在浏览器里打开网址、从这里装 App 的。
 * 只在浏览器里出现（App 里再下载一遍没有意义）；服务器上没有安装包就整块不显示。
 */
export function AppDownloadLink() {
  const { t, i18n } = useTranslation();
  const [release, setRelease] = useState<AppRelease | null>(null);

  useEffect(() => {
    if (isNative) return;
    let alive = true;
    void fetchAppRelease().then((found) => {
      if (alive) setRelease(found);
    });
    return () => {
      alive = false;
    };
  }, []);

  if (!release) return null;

  const date = new Date(release.builtAt).toLocaleDateString(i18n.language, {
    month: 'numeric',
    day: 'numeric',
  });
  const size = (release.sizeBytes / (1024 * 1024)).toFixed(1);

  return (
    <AnchorButton
      href={`/downloads/${release.file}`}
      download={release.file}
      variant="secondary"
      block
      className="flex-col gap-0.5 py-2"
    >
      <span>{t('auth.downloadApp')}</span>
      <span className="text-caption font-normal text-ink-3">
        {/* 「测试版」只给 debug 包标（CR-067）：正式签名包不该再挂着这两个字 */}
        {t(release.buildType === 'debug' ? 'auth.downloadAppMetaDebug' : 'auth.downloadAppMeta', {
          date,
          size,
        })}
      </span>
    </AnchorButton>
  );
}
